/* tslint:disable */
/* eslint-disable */
/**
 * Query Runner
 * Provides an API for running a query against records and returning detailed per query node match information.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchRecordsRequestCursorInner
 */
export interface SearchRecordsRequestCursorInner {
}

/**
 * Check if a given object implements the SearchRecordsRequestCursorInner interface.
 */
export function instanceOfSearchRecordsRequestCursorInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchRecordsRequestCursorInnerFromJSON(json: any): SearchRecordsRequestCursorInner {
    return SearchRecordsRequestCursorInnerFromJSONTyped(json, false);
}

export function SearchRecordsRequestCursorInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRecordsRequestCursorInner {
    return json;
}

export function SearchRecordsRequestCursorInnerToJSON(value?: SearchRecordsRequestCursorInner | null): any {
    return value;
}

